

<footer>
    <p class="text-white"> &copy; by Luiz Rissardi </p>
</footer>